const parseToNumber = (stringData: { [key: string]: string }) => {
	const parsedData: { [key: string]: number } = {};
	for (const key in stringData) {
		if (stringData.hasOwnProperty(key)) {
			parsedData[key] = parseFloat(stringData[key]);
		}
	}
	return parsedData;
};

export default parseToNumber;
